import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Typography from '@mui/material/Typography';

import * as wjgGrid from '@grapecity/wijmo.grid';
import * as wjCore from '@grapecity/wijmo';
import {Selector} from '@grapecity/wijmo.grid.selector';
import {FlexGridFilter} from '@grapecity/wijmo.react.grid.filter';
import {FlexGrid, FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';

import {gridOperations} from '../../reducks/grid';
import AddIconButton from '../atoms/Buttons/AddIconButton';
import DeleteIconButton from '../atoms/Buttons/DeleteIconButton';
import {
  isSmartPhone,
  formatStringDate,
  getDntIdType,
  isFloatValue,
} from '../../common/common';
import {GRID_STATUS, IDO_TYPE} from '../../common/commonConst';

/* usage
  // このファイルをimportする
  import CustomFlexGrid from '../../../../molecules/CustomFlexGrid';

  // gridのメソッドを操作するためにrefを作成
  constructor() {
    this.gridRef = React.createRef();
  }

  // render を実装
  render() {
    // デフォルトにする場合は設定しなくてよい。
    let props = {
      headersVisibility: "Column", // 行ヘッダ、列ヘッダの表示設定
                                   // "All" : 列ヘッダセルと行ヘッダセルの両方表示。デフォルト
                                   // "Column" : 列ヘッダセルのみ表示
                                   // "None" : 表示なし
                                   // "Row" : 行ヘッダセルのみ表示
      allowSorting: "SingleColumn", // 列ソート
                                    // "None" : ソートなし。デフォルト
                                    // "MultiColumn" : 一度に複数列ソート可
                                    // "SingleColumn" : 一度に1列ずつソート可
      allowDragging: "Both", // 行、列のD&D設定
                             // "Both" :  行、列両方可
                             // "Columns" : 列のみ可。デフォルト
                             // "None" : D&Dなし
                             // "Rows" : 行のみ可
      frozenRows: 1, // 行固定(デフォルト0で固定なし)
      frozenColumns: 1, // 列固定(デフォルト0で固定なし)
      data: [], //一覧に表示するデータ。後で設定する場合は書かなくてよい。
      initItems: {key1: value1, ...} // 項目と初期値を設定。
                                     // 行追加したときにinitItemsに設定した項目と初期値をグリッドに追加する。
                                     // 設定しないときはpropsに書かない。
      style: {maxHeight: "600px"}, // グリッドのスタイル設定。なければ書かなくてよい。
      rowHeaderType: "check", // 行ヘッダのスタイルを設定。
                              // "none" : なし。null,undefinedでもよい。デフォルト
                              // "check" : チェックボックス有効
                              // "radio" : ラジオボタン有効
                              // "edit" : 編集ダイアログ有効
      radioId: rowHeaderType="radio"にした場合、ラジオボタンのidを設定することができる。デフォルトは'id'。
      filterOn: true, // 列フィルター有効無効設定。true:有効。無効のときは書かなくてよい。
      exceptFilters: ['id'], // filterOn=trueのとき、フィルターを無効にする列を設定
      isDisplayCount: true, // グリッドに設定したデータ件数表示有無を設定。true:有効。無効のときは書かなくてよい。
      AddDeleteOn: true, // 行追加削除表示設定。true:有効。無効のときは書かなくてよい。
      DeleteOn: true, // 行削除ボタンのみ表示。true:有効。無効のときは書かなくてよい。
      AddAdditionOn: true, // 行追加表示設定(削除ボタン非表示)。true:有効。無効のときは書かなくてよい。
      isReadOnly: true, // true:グリッド編集不可, false:グリッド編集可。無効のときは書かなくてよい。
      trackChanges: true, // true:変更管理ON。デフォルトfalse
      screenId: '10001', // 画面ID
      isRestore: true, // true:Reduxストアに選択状態保存。デフォルトtrue
      validateEdits: true, // 検証エラー時に編集モードを維持可否
                           // true:編集モード維持, false:編集モード解除。未設定の場合はtrue
      maxRowSize: 100, // 追加可能行数。デフォルト100件。
      // 以下function。使用しない場合は書かない。
      editPopupItems: function // 編集ダイアログ処理
      refreshedFunction: function // グリッド更新時の処理
      loadedRowsFunction: function // 行がデータソースにバインドされた時に発生する処理
      itemsSourceChangedFunction: function // グリッドに新しいitemsSourceがバインドされた後に発生する処理
      formatItemFunction: function // セルを表す要素が作成されたときに発生する処理
      checkedFunction: function // 行ヘッダのチェックボックスがクリックされたときに発生する処理
      beginningEditFunction: function // セルが編集モードに入る前に発生する処理
      cellEditEndingFunction: function // セルの編集を終了したときに発生する処理
      cellEditEndedFunction: function // セルの編集を確定したときに発生する処理
      pastingCellFunction: function // クリップボードの内容をセルに貼り付けるときに発生する処理
      pastedCellFunction: function // クリップボードの内容をセルに貼り付けた後に発生する処理
      addItemFunction: function // 追加ボタンで行を追加したときの処理
      doShowMessage: function // this.props.doShowMessageを渡す
      getError: function   // 項目の特定のプロパティに検証エラーが含まれているかどうかを判定する処理
      filterChanging: function, // 列フィルターを編集する処理
    }

    // refとpropsを設定する
    <CustomFlexGrid ref={this.gridRef} {...props}>
      // 子コンポーネントを記載
    </CustomFlexGrid>

    // renderの後でdataを設定する
    if (this.gridRef && this.gridRef.current) {
        this.gridRef.current.setItemsSource(data);
    }
  }

    参考: https://www.grapecity.co.jp/developer/wijmo
*/

const MAX_DNT_COUNT = 100;
const ROW_UNIQUE_KEY = 'id';

/**
 * CustomFlexGridクラス
 */
class CustomFlexGrid extends React.Component {
  constructor(props) {
    super(props);
    this.screenId = this.props.screenId ? this.props.screenId : '';
    this.selector = null;
    this.grid = null;
    this.selectedItems = [];
    this.radioCheckId = -1;
    this.dragIndex = null;
    this.filter = null;
    this.isRestore = this.isNull(this.props.isRestore) ?
      true : this.props.isRestore;
    this.frozenRows = 0;
    this.frozenColumns = 0;
    this.rowUniqKey =
      this.props.radioId !== undefined && this.props.radioId !== null && this.props.radioId !== '' ?
      this.props.radioId : ROW_UNIQUE_KEY;
    this.maxRowSize =
      this.props.maxRowSize != undefined && this.props.maxRowSize != null ?
      this.props.maxRowSize : MAX_DNT_COUNT;

    /** チェックボックス選択順(値は行の識別ID(rowId)) */
    this.selectedOrders = [];

    // 列ヘッダーのグループをまとめて移動するために使用する
    this.dragCol = null;
    this.dragRow = null;
    this.mr = null;
    this.mrs = [];

    this.initialized = this.initialized.bind(this);
    this.initializedFilter = this.initializedFilter.bind(this);
    this.onDraggingRow = this.onDraggingRow.bind(this);
    this.onDraggedRow = this.onDraggedRow.bind(this);
    this.showRadioButton = this.showRadioButton.bind(this);

    this.checkedFunction = this.props.checkedFunction;
    this.beginningEditFunction = this.props.beginningEditFunction;
    this.cellEditEndingFunction = this.props.cellEditEndingFunction;
    this.cellEditEndedFunction = this.props.cellEditEndedFunction;
    this.pastingCellFunction = this.props.pastingCellFunction;
    this.pastedCellFunction = this.props.pastedCellFunction;
    this.doShowMessage = this.props.doShowMessage;
  }

  render() {
    const _frozenRows = this.props.frozenRows ? this.props.frozenRows : 0;
    const _frozenColumns =
      this.props.frozenColumns ? this.props.frozenColumns : 0;
    this.frozenRows = isSmartPhone() ? 0 : _frozenRows;
    this.frozenColumns = isSmartPhone() ? 0 : _frozenColumns;
    return this.renderGrid();
  }

  renderGrid() {
    const {isDisplayCount} = this.props;
    let itemCount = 0;
    const _sourceCollection = this.getSourceCollection();
    if (_sourceCollection) {
      itemCount = _sourceCollection.length;
    }
    return (
      <React.Fragment>
        {isDisplayCount &&
          <Typography variant="caption" display="block">
            {itemCount} 件
          </Typography>
        }
        <FlexGrid
          autoGenerateColumns={false}
          imeEnabled={true}
          initialized={this.initialized}
          deferResizing={false}
          showMarquee={true}
          alternatingRowStep={1}
          headersVisibility={this.props.headersVisibility ? this.props.headersVisibility : 'All'}
          allowMerging="ColumnHeaders"
          allowSorting={this.props.allowSorting ? this.props.allowSorting : 'None'}
          allowDragging={this.props.allowDragging ? this.props.allowDragging : 'Columns'}
          selectionMode={this.props.rowHeaderType === 'Row' ? 'Row' : 'MultiRange'}
          style={this.props.style ? this.props.style : {maxHeight: '300pt'}}
          frozenRows={this.frozenRows}
          frozenColumns={this.frozenColumns}
          isReadOnly={!!this.props.isReadOnly}
          validateEdits={
                  typeof this.props.validateEdits !== 'undefined' ? this.props.validateEdits : true}
          draggingRow={this.onDraggingRow}
          draggedRow={this.onDraggedRow}
          bigCheckboxes={true}
          itemsSource={this.props.itemsSource}
          {...this.props.flexGridProps}
        >
          {(this.props.AddDeleteOn || this.props.DeleteOn) &&
            <FlexGridColumnGroup
              binding="edit" header="削除"
              align="center" width={42}
            />
          }
          {this.props.AddAdditionOn &&
            <FlexGridColumnGroup
              binding="edit" header=" "
              align="center" width={60}
            />
          }
          {this.props.rowHeaderType == 'radio' && <FlexGridColumnGroup binding="Id" header=" " align="center" width={60}/>}
          {this.props.children}
          {this.props.filterOn &&
                  <FlexGridFilter initialized={this.initializedFilter}/>}
        </FlexGrid>
        <DeleteIconButton isDisabled={!!this.props.isReadOnly}/>
        <AddIconButton isDisabled={!!this.props.isReadOnly}/>
      </React.Fragment>
    );
  }

  /**
   * Draggingイベント
   * @param {object} s
   * @param {object} e
   */
  onDraggingRow(s, e) {
    this.dragIndex = e.row;
  }

  /**
   * Draggedイベント
   * @param {object} s
   * @param {object} e
   */
  onDraggedRow(s, e) {
    let cv = s.collectionView;
    try {
      let dropIndex = e.row;
      cv.beginUpdate();
      cv.sortDescriptions.clear();
      let items = cv.sourceCollection;
      let selectedItem = items[this.dragIndex];
      // 選択した行を削除
      cv.sourceCollection.splice(this.dragIndex, 1);
      // 行移動
      cv.sourceCollection.splice(dropIndex, 0, selectedItem);
    } catch (error) {
      // do nothing
    } finally {
      cv.endUpdate();
      cv.refresh();
    }
  }

  showEditIcon(s, e) {
    // 行ヘッダに編集アイコンを表示
    if (e.panel === s.rowHeaders &&
        e.col === (s.rowHeaders.columns.length - 1)) {
      if (s.rowHeaders.rows[e.row].isReadOnly) {
        e.cell.innerHTML = '<div></div>';
      } else {
        e.cell.innerHTML = '<div><span id="popupEdit" class="wj-glyph-pencil"></span></div>';
      }
    }
  }

  showRadioButton(s, e) {
    if (e.panel.cellType == wjgGrid.CellType.Cell && e.col == 0) {
      const items = s.rows ? s.rows : [];
      if (items.length == 0) {
        return;
      }
      const uniqueId = items[e.row].dataItem &&
      Object.hasOwn(items[e.row].dataItem, this.rowUniqKey) ?
      items[e.row].dataItem[this.rowUniqKey] : e.row;
      e.cell.innerHTML = '<div style="text-align:center"><input type="radio" name="envId" id="'+ uniqueId +'" style="transform:scale(1.3);" /></div>';
      const radio = e.cell.children[0];
      if (uniqueId == this.radioCheckId) {
        radio.childNodes['0'].checked = true;
      }
    }
  }

  setCheckBox(grid) {
    // 行ヘッダにチェックボックスを表示
    this.selector = new Selector(grid, {
      itemChecked: (s, e) => {
        this.selectedItems = grid.rows.filter((r) => r.isSelected);

        // チェックボックスクリック時イベントがあれば実行
        if (this.checkedFunction) {
          this.checkedFunction();
        }
      },
    });
    this.selector.column.grid.headersVisibility = wjgGrid.HeadersVisibility.All;
    this.selector.column =
      this.selector.column.grid.rowHeaders.columns.length == 2 ?
      this.selector.column.grid.rowHeaders.columns[1] :
      this.selector.column.grid.rowHeaders.columns[0];
    this.selectedItems = [];
    this.selectedOrders = [];
  }

  initialized(grid) {
    this.grid = grid;

    this.dragCol = null;
    this.dragRow = null;
    this.mr = null;
    this.mrs = [];

    const rowHeaderType = this.props.rowHeaderType;
    const AddDeleteOn = this.props.AddDeleteOn;
    const AddAdditionOn = this.props.AddAdditionOn;

    if (this.props.data) {
      this.grid.itemsSource = createCollectionView(
          this.props.data, !!this.props.trackChanges,
          this.props.initItems, this.props.getError);
    }

    // editの場合、行ヘッダーを2行にする
    if (rowHeaderType == 'edit') {
      grid.rowHeaders.columns.push(new wjgGrid.Column());
      grid.rowHeaders.columns[0].width = 15;
    }

    // 行ヘッダー設定(チェックボックス)
    if (rowHeaderType === 'check') {
      this.setCheckBox(grid);
    }

    // 左上のセルを連結して1つのセルにする
    for (const col of grid.topLeftCells.columns) {
      col.allowMerging = true;
      col.cssClassAll = 'bf-top-left-style';
    }

    // 行追加、削除ボタン設定
    if (AddDeleteOn || AddAdditionOn) {
      // add a footer row
      const footerRow = new wjgGrid.GroupRow();
      footerRow.height = 50;
      grid.columnFooters.rows.push(footerRow);
    }

    // セルの書式設定を行う
    const _formatItemHandler = this.formatItemHandler.bind(this);
    grid.formatItem.addHandler(_formatItemHandler);

    const _resizingColumnHandler = this.resizingColumnHandler.bind(this);
    grid.resizingColumn.addHandler(_resizingColumnHandler);

    // コントロールが内容を更新した後で発生する処理
    const _refreshedHandler = this.refreshedHandler.bind(this);
    grid.refreshed.addHandler(_refreshedHandler);

    // グリッド行がデータソースの項目に連結された後に発生する処理
    const _loadedRowsHandler = this.loadedRowsHandler.bind(this);
    grid.loadedRows.addHandler(_loadedRowsHandler);

    // 列ヘッダーのグループをまとめて移動するために使用する start
    const _draggingColumnHandler = this.draggingColumnHandler.bind(this);
    grid.draggingColumn.addHandler(_draggingColumnHandler);

    const _draggingColumnOverHandler =
      this.draggingColumnOverHandler.bind(this);
    grid.draggingColumnOver.addHandler(_draggingColumnOverHandler);
    // 列ヘッダーのグループをまとめて移動するために使用する end

    const _beginningEditHandler = this.beginningEditHandler.bind(this);
    grid.beginningEdit.addHandler(_beginningEditHandler);

    // セル編集終了時の処理
    const _cellEditEndingHandler = this.cellEditEndingHandler.bind(this);
    grid.cellEditEnding.addHandler(_cellEditEndingHandler);

    // セル編集確定時の処理
    const _cellEditEndedHandler = this.cellEditEndedHandler.bind(this);
    grid.cellEditEnded.addHandler(_cellEditEndedHandler);

    // セルペースト時の処理
    const _pastingCellHandler = this.pastingCellHandler.bind(this);
    grid.pastingCell.addHandler(_pastingCellHandler);

    // セルペースト後の処理
    const _pastedCellHandler = this.pastedCellHandler.bind(this);
    grid.pastedCell.addHandler(_pastedCellHandler);

    // 行選択時の処理
    const _selectionChangedHandler = this.selectionChangedHandler.bind(this);
    grid.selectionChanged.addHandler(_selectionChangedHandler);

    // itemsSource変更後の処理
    const _itemsSourceChangedHandler =
      this.itemsSourceChangedHandler.bind(this);
    grid.itemsSourceChanged.addHandler(_itemsSourceChangedHandler);

    const _hostElementClickEvent = this.hostElementClickEvent.bind(this);
    grid.hostElement?.addEventListener('click', _hostElementClickEvent);

    const _hostElementChangeEvent = this.hostElementChangeEvent.bind(this);
    grid.hostElement?.addEventListener('change', _hostElementChangeEvent);

    // wijmo不具合対応 start
    // react18、collectionviewにgetErrorを設定しているとき、
    // セルを選択すると選択処理をループしてしまう
    // 回避方法を追加。wijmoの不具合が解消したら削除してよい
    grid.selectionChanging._handlers = [];
    const _selectionChangingHandler = this.selectionChangingHandler.bind(this);
    grid.selectionChanging.addHandler(_selectionChangingHandler);
    // wijmo不具合対応 end

    // カスタム初期化処理
    if (this.props.initializedFunction) {
      this.props.initializedFunction(this.grid);
    }
  }

  formatItemHandler(s, e) {
    const rowHeaderType = this.props.rowHeaderType;
    // ヘッダーのみ折り返す
    wjCore.toggleClass(e.cell, 'wj-wrap', s.columnHeaders === e.panel);

    // 列ヘッダーフォーマット
    this.formatColumnHeaders(s, e);

    if (this.props.AddDeleteOn) {
      this.setAddDeleteButton(s, e);
    } else if (this.props.DeleteOn) {
      this.setDeleteButton(s, e);
    }

    if (this.props.AddAdditionOn) {
      this.setAddAdditionButton(s, e);
    }

    // 行ヘッダー設定
    if (rowHeaderType === 'edit') {
      this.showEditIcon(s, e);
    }
    if (rowHeaderType === 'radio') {
      this.showRadioButton(s, e);
    }

    // グレーアウトする行はチェックボックスを非活性にする
    if ((rowHeaderType == 'check') &&
        (e.panel.cellType == wjgGrid.CellType.RowHeader)) {
      if (s.rows[e.row].cssClass == 'bf-gray') {
        wjCore.addClass(e.cell, 'wj-state-disabled');
      } else {
        wjCore.removeClass(e.cell, 'wj-state-disabled');
      }
    }

    // ヘッダー2行目高さ調整
    this.formatColumnHeadersRows(this.grid);

    // セルの書式設定
    if (this.props.formatItemFunction) {
      this.props.formatItemFunction(s, e);
    }
  }

  setAddDeleteButton(s, e) {
    const col = s.columns[e.col];
    this.setDeleteButton(s, e);
    // add footer button
    if (e.panel === s.columnFooters && col.binding === 'edit' &&
          document.getElementById('btnTblFooter')) {
      e.cell.innerHTML = document.getElementById('btnTblFooter').innerHTML; // AddIconButtonのid
    }
  }

  setDeleteButton(s, e) {
    const col = s.columns[e.col];
    // add edit button
    if (e.panel === s.cells) {
      const item = s.rows[e.row].dataItem;
      if (col.binding === 'edit') {
        e.cell.innerHTML = document.getElementById('btnMode').innerHTML; // DeleteIconButtonのid
        if (s.rows[e.row].isReadOnly) {
          e.cell.querySelector('#iconDeleteRow').setAttribute('disabled', true);
        }
        e.cell['dataItem'] = item;
      }
    }
  }

  setAddAdditionButton(s, e) {
    const col = s.columns[e.col];
    // add edit button
    if (e.panel === s.cells) {
      const item = s.rows[e.row].dataItem;
      if (col.binding === 'edit') {
        e.cell.innerHTML = ''; // 削除アイコンの非表示
        e.cell['dataItem'] = item;
      }
    }
    // add footer button
    if (e.panel === s.columnFooters && col.binding === 'edit' &&
          document.getElementById('btnTblFooter')) {
      e.cell.innerHTML = document.getElementById('btnTblFooter').innerHTML; // AddIconButtonのid
    }
  }

  formatColumnHeaders(s, e) {
    if (s.columnHeaders !== e.panel) {
      return;
    }
    if (!e.cell.innerHTML) {
      return;
    }
    // 列ヘッダーに\nがあれば<br/>に置換する
    if (e.cell.innerHTML.indexOf('\\n') != -1) {
      e.cell.innerHTML = e.cell.innerHTML.replace(/\\n/g, '<br/>');
    }
    if (e.cell.innerHTML.indexOf('\n') != -1) {
      e.cell.innerHTML = e.cell.innerHTML.replace(/\n/g, '<br/>');
    }
    // 列ヘッダーの文字列を中央に表示する
    let html = e.cell.innerHTML;
    // 列ヘッダーが1行の場合
    if (s.columnHeaders.rows.length == 1) {
      if (html.search(/^<div>/g) == -1) {
        e.cell.innerHTML = '<div class="bf-HeaderCenter">' + html + '</div>';
      } else {
        wjCore.toggleClass(e.cell, 'bf-HeaderCenter');
      }
    }
    // 列ヘッダーが2行以上の場合
    if (s.columnHeaders.rows.length >= 2 &&
        e.row == (s.columnHeaders.rows.length - 1)) {
      if (html.search(/^<div>/g) == -1) {
        e.cell.innerHTML = '<div class="bf-HeaderCenter">' + html + '</div>';
      } else {
        wjCore.toggleClass(e.cell, 'bf-blockCenter');
      }
    }
  }

  formatColumnHeadersRows(grid) {

    /* ヘッダー高の調整はしない
    if (grid.columnHeaders.rows.length < 2) {
      return;
    }
    const rowLength = grid.columnHeaders.rows.length - 1;
    for (const column of grid.columnHeaders.columns) {
      const width = column.header.length * 2 * 16;
      const size = column.size ? column.size : width;
      if (width > size && column.level == rowLength) {
        const count = Math.round(Number( width / size ));
        const calc = 37 + 10 * count;
        if (calc > grid.columnHeaders.rows[rowLength].height) {
          grid.columnHeaders.rows[rowLength].height = calc;
        }
      }
    }
    */
  }

  resizingColumnHandler(s, e) {
    // ヘッダーのみ、列幅変更時に高さを変更し、列名を見えるようにする
    for (let i = 0; i < this.grid.columnHeaders.rows.length; i++) {
      if (this.grid.columnHeaders.getCellElement(i, e.col)) {
        const height =
        this.grid.columnHeaders.getCellElement(i, e.col).scrollHeight;
        if (height > this.grid.columnHeaders.rows.defaultSize) {
          this.grid.autoSizeRow(i, true);
        }
      }
    }
  }

  selectionChangedHandler(s, e) {
    if (this.props.selectionChangedFunction) {
      this.props.selectionChangedFunction(s, e);
    }
  }

  itemsSourceChangedHandler(s, e) {
    if (this.props.itemsSourceChangedFunction) {
      this.props.itemsSourceChangedFunction(s, e);
    } else {
      let count = 0;
      for (const column of s.columns) {
        // visibleがfalseだと自動調整されないため一時的にtrue
        let orgVisibe = column.visible;
        if (!orgVisibe) {
          column.visible = true;
        }
        if (column.isReadOnly &&
            column.quickAutoSize !== false) {
          // 参照のみかつ、quickAutoSizeがfalse指定でなければ、自動列幅調整を行う
          s.autoSizeColumn(count);
        } else if (!column.isReadOnly &&
          column.quickAutoSize !== false &&
          column.dataType === 1) {
          // 編集ありかつ、、quickAutoSizeがfalse指定でないかつ、
          // stringの列のみに対して自動列幅調整を行う
          // 1:string, 2:number, 3:boolean, 4:date
          s.autoSizeColumn(count);
        }
        // visibleを戻す
        if (!orgVisibe) {
          column.visible = false;
        }
        count++;
      }
    }
  }


  refreshedHandler(s, e) {
    if (this.props.refreshedFunction) {
      this.props.refreshedFunction(s, e);
    }
  }

  loadedRowsHandler(s, e) {
    if (s.rows && this.isRestore) {
      this.restore(s, e);
    }
    if (this.props.loadedRowsFunction) {
      this.props.loadedRowsFunction(s, e);
    }
  }

  restore(s, e) {
    const rowHeaderType = this.props.rowHeaderType;
    this.restoreSelectedItems(rowHeaderType);
    this.restoreScrollPosition();
    if (rowHeaderType === 'check') {
      // チェックボックスの選択状態を復元
      this.onItemChecked();
    }
    if (rowHeaderType === 'radio') {
      // ラジオボタンの選択状態を復元
      if (s.rows.length == 0) {
        this.selectedItems = [];
      } else {
        const hasId = (s.rows.filter((r) => r.dataItem &&
        Object.hasOwn(
            r.dataItem, this.rowUniqKey)).length > 0);
        if (hasId) {
          this.selectedItems =
          s.rows.filter((r) => r.dataItem &&
            Object.hasOwn(r.dataItem, this.rowUniqKey) &&
            (r.dataItem[this.rowUniqKey] == this.radioCheckId));
        } else {
          this.selectedItems =
          s.rows.filter((r) => r.index == this.radioCheckId);
        }
      }
      if (this.selectedItems.length == 0) {
        this.grid.select(-1, -1);
      }
      if (this.checkedFunction) {
        this.checkedFunction();
      }
    }

    if (rowHeaderType === 'Row') {
      this.grid.select(-1, -1);
    }
  }

  draggingColumnHandler(s, e) {
    this.dragCol = e.range.col;
    this.dragRow = e.range.row;

    this.mr = s.getMergedRange(s.columnHeaders, 0, this.dragCol);

    if (this.canDraggingColumn(s, e, this.dragRow, this.mr)) {
      e.cancel = true;
      return;
    }

    // ドラッグ時の結合状態を取得
    this.mrs.length = 0;
    for (let i = 0; i < s.columns.length; ) {
      let tmpMr = s.getMergedRange(s.columnHeaders, 0, i);
      if (tmpMr && tmpMr.col != tmpMr.col2) {// 複数列のグループ
        this.mrs.push(tmpMr);
        i = tmpMr.col2;
      } else if (s.columnHeaders.rows.length > 1) {// 1列のグループ
        if (tmpMr && tmpMr.col == tmpMr.col2 && tmpMr.rowSpan == 1) {
          this.mrs.push(tmpMr);
          i = tmpMr.col2;
        }
      }
      i++;
    }
  }

  canDraggingColumn(s, e, dragRow, mr) {
    // 子要素の場合はドラッグさせない
    if (dragRow == 1 && mr.col != mr.col2) {
      return true;
    }
    if (dragRow == 1 &&
        mr.col == mr.col2 && mr.rowSpan == 1) {
      return true;
    }
    if (s.frozenColumns > 0) {
      // ドロップ位置がfrozenColumnよりも小さい場合はキャンセル
      if (e.col < s.frozenColumns) {
        return true;
      }
    }
    return false;
  }

  draggingColumnOverHandler(s, e) {
    // ドロップ先がドラッグ時の左側か右側か判定
    let flg = e.range.col - this.dragCol > 0;
    // ドロップ位置がfrozenColumnよりも小さい場合はキャンセル
    if (s.frozenColumns > 0 && e.col < s.frozenColumns) {
      e.cancel = true;
      return;
    }
    // ドロップ先が結合セル内かどうか判定
    for (const _mrs of this.mrs) {
      // ドロップ先が結合セル内の場合
      if (_mrs.col > e.range.col || _mrs.col2 < e.range.col) {
        continue;
      }
      if (this.isMergeCol(s, e, this.mr, _mrs, flg)) {
        e.cancel = true;
        return;
      }
    }
  }

  isMergeCol(s, e, mr, _mrs, flg) {
    if ((mr.col == _mrs.col && mr.col2 == _mrs.col2) || // 同一結合セル内の場合
    (flg && _mrs.col2 > e.range.col) || // ドロップ先が右側で結合セルの右端でない場合
    (!flg && _mrs.col < e.range.col)) { // ドロップ先が左側で結合セルの左端でない場合
      return true;
    } else {
      if (s.columnHeaders.rows.length > 1 && e.range.row != 0) {// グループの1行目以外の場合
        return true;
      }
    }
    return false;
  }

  beginningEditHandler(s, e) {
    if (this.cellEditCancel(e)) {
      return;
    }
    if (this.beginningEditFunction) {
      this.beginningEditFunction(s, e);
    }
  }

  cellEditEndingHandler(grid, event) {
    if (this.cellEditEndingFunction) {
      this.cellEditEndingFunction(grid, event);
    }
  }

  cellEditEndedHandler(grid, event) {
    // セルのデータ型が数値で、フォーマットが整数（n0 or d）のとき、
    // 入力した値を四捨五入して整数にする
    if (this.isIntegerCell(event)) {
      const value = grid.getCellData(event.row, event.col, false);
      if (isFloatValue(value)) {
        grid.setCellData(event.row, event.col, Math.round(value));
      }
    }

    if (this.cellEditEndedFunction) {
      this.cellEditEndedFunction(grid, event);
    }
  }

  pastedCellHandler(grid, event) {
    if (this.pastedCellFunction) {
      this.pastedCellFunction(grid, event);
    }
  }

  pastingCellHandler(grid, event) {
    if (this.cellEditCancel(event)) {
      return;
    }

    // セルのデータ型が数値で、フォーマットが整数（n0 or d）のとき、
    // 入力した値を四捨五入して整数にする
    if (this.isIntegerCell(event)) {
      const data = event.data;
      let value = null;
      if (data !== undefined && data !== null) {
        // カンマ付きの数値を貼り付けることができるので、数値判定のためにカンマを除く
        // 全角・半角スペースありの値も入力できるので、数値判定のために値の前後の全角・半角スペースを除く
        value = data.replace(/,|^[\s\u3000]+|[\s\u3000]+$/g, '');
      }
      if (isFloatValue(value)) {
        event.data = Math.round(value);
      } else if (value === null || value === '') {
        event.data = value;
      } else {
        event.cancel = true;
        return;
      }
    }

    if (this.pastingCellFunction) {
      this.pastingCellFunction(grid, event);
    }
  }

  cellEditCancel(event) {
    const element = event.panel.getCellElement(event.row, event.col);
    // 'wj-state-disabled'が設定してあるセルは編集不可
    if (element !== undefined && element !== null &&
        element.className?.indexOf('wj-state-disabled') != -1) {
      event.cancel = true;
    }
    return event.cancel;
  }

  isIntegerCell(event) {
    let result = false;
    if (event.panel.cellType === wjgGrid.CellType.Cell) {
      const col = event.getColumn();
      // セルのデータ型が数値で、フォーマットが整数（n0 or d）のとき、trueを返す
      if (col.dataType === wjCore.DataType.Number &&
          !col.isReadOnly &&
          (col.format === 'n0' || col.format === 'd')) {
        result = true;
      }
    }
    return result;
  }

  async hostElementClickEvent(e) {
    let key = e.target.id;
    if (e.target.nodeName == 'path') {
      // material UI のSVG IconはnodeNameがpathになる
      key = e.target.parentNode.id;
    }
    const cv = this.grid.collectionView;
    if (!cv?.sourceCollection) {
      return;
    }

    // チェックボックスをチェックした順序を保持する
    this._setSelectedOrders(e);

    switch (key) {
      case 'btnDeleteRow': {
        const ht = this.grid.hitTest(e);
        let deletedRow = cv.currentItem;
        if (ht) {
          // 削除した行の識別IDを取得
          const deletedIndex = ht.row;
          const row = this.grid.rows[deletedIndex];
          const rowId = row.dataItem.rowId;

          cv.beginUpdate();
          cv.removeAt(deletedIndex);
          if (cv.sourceCollection.length > 0 ) {
            let index = 1;
            for (const item of cv.sourceCollection) {
              item['rowIndex'] = index++;
            }
          }
          cv.endUpdate();

          // 削除した行の識別IDがチェックボックス選択順にあれば除去
          this.selectedOrders = this.selectedOrders.filter(
              (order) => order !== rowId);

          if (this.props.deleteRowFunction) {
            this.props.deleteRowFunction(e, cv, deletedRow);
          }
        }
        break;
      }
      case 'btnAddRow': {
        this.btnAddRowClickEvent(e, cv);
        break;
      }
      case 'popupEdit': {
        if (this.props.editPopupItems) {
          const ht = this.grid.hitTest(e);
          if (ht.panel !== this.grid.rowHeaders) {
            return;
          }
          let _editItem = this.grid.rows[ht.row].dataItem;
          if (!_editItem) {
            return;
          }
          this.props.editPopupItems(this.grid, _editItem, e);
        }
        break;
      }
      default:
        break;
    }
  }

  /**
   * チェックボックス選択順の設定。
   *
   * チェックボックスをクリックした場合にチェックした順を保持する。
   *
   * @param {object} e クリックイベント
   */
  _setSelectedOrders(e) {
    // 選択チェックボックスではない場合は何もしない
    if (!wjCore.closestClass(e.target, 'wj-column-selector')) {
      return;
    }

    const ht = this.grid.hitTest(e);
    const cellType = ht.panel?.cellType;

    // ヘッダ行先頭のチェックボックスをクリックした場合
    if (cellType === wjgGrid.CellType.TopLeft) {
      if (e.target.checked) {
        // チェックした場合はチェック選択順に、現在表示されている全行を設定
        this.selectedOrders = this.grid.rows.map((row) => (row.dataItem.rowId));
      } else {
        // チェック解除した場合はチェック選択順をクリア
        this.selectedOrders = [];
      }

      return;
    }

    // データ行先頭のチェックボックスをクリックした場合
    if (cellType === wjgGrid.CellType.RowHeader) {
      // チェックした行の識別IDを取得
      const row = this.grid.rows[ht.row];
      const checkedRowId = row.dataItem.rowId;

      if (e.target.checked) {
        // チェックした場合はチェック選択順の最後に追加
        this.selectedOrders.push(checkedRowId);
      } else {
        // チェック解除した場合はチェック選択順から除去
        this.selectedOrders = this.selectedOrders.filter((rowId) =>{
          return rowId !== checkedRowId;
        });
      }

      return;
    }
  }

  btnAddRowClickEvent(e, cv) {
    let _itemsCount = cv.sourceCollection.length;
    if (_itemsCount >= this.maxRowSize) {
      if (this.doShowMessage) {
        this.doShowMessage({
          message: {
            id: 'BFY000053E',
            values: [this.maxRowSize],
          },
        });
      }
      return;
    }
    cv.beginUpdate();
    const _nextRowId = this.getNextRowId(cv.sourceCollection);
    const _nextRowIndex = this.getNextRowIndex(cv.sourceCollection);
    const _nextBukkenNo = this.getNextBukkenNo(cv.sourceCollection);
    const _nextKanrenDempyoNo =
      this.getNextBKanrenDempyoNo(cv.sourceCollection, cv.itemsRemoved);
    const _newItem = cv.addNew();
    if (_newItem) {
      _newItem['rowId'] = _nextRowId;
      _newItem['rowIndex'] = _nextRowIndex;
      _newItem['gridStatus'] = GRID_STATUS.INSERT;
      if ( _nextKanrenDempyoNo > 0) {
        _newItem['kojiDempyoTuban'] = _nextKanrenDempyoNo;
      }
      if (Object.hasOwn(_newItem, 'bukkenNo')) {
        _newItem['bukkenNo'] = _nextBukkenNo;
      }
      if (this.props.addItemFunction) {
        this.props.addItemFunction(e, cv, _newItem);
      }
      cv.commitNew();
    }
    cv.endUpdate();
  }

  getNextRowId(sourceCollection) {
    let maxRowId = 0;
    if (sourceCollection.length > 0) {
      maxRowId = sourceCollection.reduce((src, dest) => {
        return src.rowId > dest.rowId ? src : dest;
      }).rowId;
    }
    return maxRowId + 1;
  }

  getNextRowIndex(sourceCollection) {
    let maxRowIndex = 0;
    if (sourceCollection.length > 0) {
      maxRowIndex = sourceCollection.reduce((src, dest) => {
        return src.rowIndex > dest.rowIndex ? src : dest;
      }).rowIndex;
    }
    return maxRowIndex + 1;
  }

  getNextBukkenNo(sourceCollection) {
    let _maxBukkenNo = 1;
    if (sourceCollection == null || sourceCollection.length == 0) {
      return _maxBukkenNo;
    }
    const hasBukkenNo = Object.hasOwn(sourceCollection[0], 'bukkenNo');
    if (!hasBukkenNo) {
      return _maxBukkenNo;
    }
    _maxBukkenNo = sourceCollection.reduce((src, dest) => {
      return src.bukkenNo > dest.bukkenNo ? src : dest;
    }).bukkenNo;
    return _maxBukkenNo == null ? 1 : _maxBukkenNo + 1;
  }

  getNextBKanrenDempyoNo(source, removedItems) {
    let _maxKanrenDempyoNo = 0;
    const hasKanrenDempyoNo = this.grid.columns.filter((column) => column.binding == 'kojiDempyoTuban').length > 0;
    if (!hasKanrenDempyoNo) {
      return _maxKanrenDempyoNo;
    }
    if (hasKanrenDempyoNo && source.length > 0) {
      _maxKanrenDempyoNo = source.reduce((src, dest) => {
        return src.kojiDempyoTuban > dest.kojiDempyoTuban ? src : dest;
      }).kojiDempyoTuban;
    }
    let _maxRemovedKanrenDempyoNo = 0;
    if (hasKanrenDempyoNo && removedItems.length > 0) {
      _maxRemovedKanrenDempyoNo = removedItems.reduce((src, dest) => {
        return src.kojiDempyoTuban > dest.kojiDempyoTuban ? src : dest;
      }).kojiDempyoTuban;
    }

    return _maxKanrenDempyoNo > _maxRemovedKanrenDempyoNo ?
      _maxKanrenDempyoNo+1 : _maxRemovedKanrenDempyoNo+1;
  }

  hostElementChangeEvent(e) {
    if (!(e.target instanceof HTMLInputElement)) {
      return;
    }
    if (e.target.type === 'radio' && e.target.name === 'envId') {
      // 選択行を取得
      const hasId = (this.grid.rows.filter((r) => r.dataItem &&
        Object.hasOwn(r.dataItem, this.rowUniqKey)).length > 0);
      this.radioCheckId = e.target.id;
      if (hasId) {
        this.selectedItems =
        this.grid.rows.filter((r) => r.dataItem &&
            Object.hasOwn(r.dataItem, this.rowUniqKey) &&
            (r.dataItem[this.rowUniqKey] == this.radioCheckId));
        // ソートすると前回保存した選択状態を復元してしまうので、ラジオONにしたときに状態を保存する
        this.saveSelectedItems(this.screenId, this.rowUniqKey);
      } else {
        this.selectedItems =
        this.grid.rows.filter((r) => r.index == this.radioCheckId);
      }
      // クリック時イベントがあれば設定
      if (this.checkedFunction) {
        this.checkedFunction(e);
      }
    }
  }

  selectionChangingHandler(s, e) {
    let g = this.grid;
    let _this = this.grid._edtHdl;
    if (!_this.finishEditing()) {
      e.cancel = true;
      return;
    }
    let oldRow1 = g._selHdl.selection.row;
    if (oldRow1 == e.row) {
      return;
    }
    let len = g.rows.length;
    let oldItem = oldRow1 > -1 && oldRow1 < len ?
      g.rows[oldRow1].dataItem : null;
    let newItem = e.row > -1 && e.row < len ?
      g.rows[e.row].dataItem : null;
    if (oldItem == newItem) {
      return;
    }
    _this._commitRowEdits();
    if (!g._getHasValidation()) {
      return;
    }
    let _validateEdits = g.validateEdits ?
    g.getEmptyRequiredCell(oldRow1) : null;
    let erc1 = !g.rows[oldRow1] || (g.rows[oldRow1] &&
    (Object.getPrototypeOf(g.rows[oldRow1]) !==
    wjgGrid.Row.prototype)) ? null : _validateEdits;
    if (erc1 !== null) {
      setTimeout(function() {
        g.select(new wjgGrid.CellRange(oldRow1, erc1));
        _this.startEditing(true, oldRow1, erc1, true, e);
      });
    }
  }

  initializedFilter(filter) {
    this.filter = filter;
    const self = this;
    // フィルターが不要な列を"フィルターなし"にする
    const str = [];
    let exceptFilters = this.props.exceptFilters;
    if (!exceptFilters) {
      exceptFilters = [];
    }
    for (const key of ['edit', 'Id']) {
      exceptFilters.push(key);
    }
    const columns = this.filter.grid.columns;
    columns.forEach(function(col) {
      if (col.binding && !exceptFilters.includes(col.binding)) {
        str.push(col.binding);
      }
    });
    this.filter.filterColumns = str;
    this.filter.showSortButtons = false;

    this.filter.filterChanging.addHandler((s, e) => {
      let edt = s.activeEditor;
      let lbHost = edt.hostElement.querySelector('[wj-part=div-values]');
      let lb = wjCore.Control.getControl(lbHost);
      if (e.getColumn().dataType == wjCore.DataType.Boolean) {
        lb.itemFormatter = (index) => {
          let result = '(なし)';
          if (lb.collectionView.items[index].value === true) {
            result = 'ON';
          } else if (lb.collectionView.items[index].value === false) {
            result = 'OFF';
          }
          return result;
        };
      }

      if (self.props.filterChanging) {
        self.props.filterChanging(s, e);
      }

      lb.collectionView.refresh();
    });
  }

  /**
   * チェックボックスまたはラジオボタンで選択した行データを返す
   * @return {array} 選択行
   */
  selectedItem() {
    return this.selectedItems != null ? this.selectedItems : [];
  }

  /**
   * 選択行の件数を返す
   * @return {number}
   */
  selectedItemCount() {
    return this.selectedItems != null ? this.selectedItems.length : 0;
  }

  /**
   * チェックした順序で選択行を返す
   * @return {object[]} 選択行
   */
  orderedSelectedItem() {
    // ラジオボタンの場合はそのまま返却
    if (this.props.rowHeaderType === 'radio') {
      return this.selectedItem();
    }

    // チェックした順にGridの行情報を取得
    return this.selectedOrders.map(
        (rowId) => this.grid.rows.find(
            (row) => row.dataItem.rowId === rowId,
        ),
    // 絞り込みなどで取得できなかった行は返さない
    ).filter((row) => row !== undefined);
  }

  /**
   * チェックボックスチェンジイベント発行
   */
  onItemChecked() {
    if (this.selector) {
      this.selector.onItemChecked();
    }
  }

  /**
   * レンダー前のチェックボックス状態を復元する
   * @param {array} items RowCollection
   */
  reItemChecked(items) {
    if (!items || items.length == 0) {
      return;
    }
    if (this.grid?.rows == null ||
        this.grid.rows.length == 0) {
      return;
    }
    for (const item of items) {
      const rowIndex = this.grid.rows.indexOf(item);
      if (rowIndex != -1) {
        this.grid.rows[rowIndex].isSelected = true;
      }
    }
    this.onItemChecked();
  }

  /**
   * バインドしたデータのisSelectedを設定
   * @param {bool} selected true:選択、false:未選択
   */
  setAllSelected(selected) {
    if (this.grid != null && this.grid.rows.length > 0) {
      for (const row of this.grid.rows) {
        row.isSelected = selected;
      }
    }
  }

  /**
   * ラジオボタン、チェックボックスの選択状態復元
   * @param {string} rowHeaderType ヘッダーに表示する選択項目名
   */
  restoreSelectedItems(rowHeaderType) {
    const _screenId = this.screenId + '_grid';
    const selection = this.props.selections.filter(
        (data) => data.screenId == _screenId);
    let isEmptySelection = function(grid, selection) {
      return (grid?.rows == null ||
        grid.rows.length == 0 ||
        selection.length == 0 ||
        !selection[0].compareKey ||
        selection[0].selectedItems == null ||
        selection[0].selectedItems.length == 0);
    };
    if (isEmptySelection(this.grid, selection)) {
      return;
    }

    // チェックボックス選択順をクリア
    this.selectedOrders = [];

    // キーが一致するデータを選択する
    const compareKey = selection[0].compareKey;
    const selectedItems = selection[0].selectedItems;
    if (!Object.hasOwn(selectedItems[0], compareKey) ||
      !Object.hasOwn(this.grid.rows[0].dataItem, compareKey)) {
      return;
    }
    for (const selectedItem of selectedItems) {
      const sameRow = this.grid.rows.find(
          (row) => row.dataItem[compareKey] == selectedItem[compareKey]);
      if (!sameRow) {
        continue;
      }

      if (rowHeaderType === 'check') {
        sameRow.isSelected = true;
        this.selectedOrders.push(sameRow.dataItem.rowId);
      }
      if (rowHeaderType === 'radio') {
        const hasKey = sameRow.dataItem &&
          Object.hasOwn(sameRow.dataItem, compareKey);
        this.radioCheckId = sameRow.index;
        if (hasKey) {
          this.radioCheckId = sameRow.dataItem[compareKey];
        }
      }
    }
  }

  /**
   * スクロール位置復元
   */
  restoreScrollPosition() {
    if (this.screenId) {
      if (this.grid == null || this.grid.rows == null ||
          this.grid.rows.length == 0) {
        return;
      }
      const _screenId = this.screenId + '_grid';
      const dataList = this.props.scrollPosition.filter(
          (data) => data.screenId == _screenId);
      if (dataList.length == 0 ||
        dataList[0].scrollPosition == null) {
        return;
      }
      this.grid.scrollPosition = new wjCore.Point(
          dataList[0].scrollPosition.x, dataList[0].scrollPosition.y);
      this.grid.refresh(false);
    }
  }

  /**
   * グリッドを返す
   * @return {object} グリッド本体
   */
  getGrid() {
    return this.grid;
  }

  /**
   * CollectionViewのデータを返す
   * @return {array} 基になる（フィルタリングもソートもされていない）データ
   */
  getSourceCollection() {
    return this.grid?.collectionView?.sourceCollection ?
      this.grid?.collectionView?.sourceCollection : [];
  }

  /**
   * CollectionViewのデータを返す
   * @return {array} フィルタリング、ソート、グループ化が適用されたデータ
   */
  getItems() {
    return this.grid?.collectionView?.items ?
      this.grid?.collectionView?.items : [];
  }

  /**
   * コレクションビュー取得
   */
  getView() {
    return this.grid?.collectionView;
  }

  /**
   * 追加、変更、削除したデータを返す
   * 注意)CollectionView メソッド（editItem /commitEdit、 addNew /commitNew、remove）を使用しないと
   *     同じ行を追加、削除したとき、 itemsAddedとitemsRemovedにそれぞれデータが入る。
   *     同じ行を複数回変更したとき、変更した回数分itemsEditedにデータが入る。
   * @return {array} 追加、変更、削除したデータ
   */
  itemChangedList() {
    let _items = [];
    if (this.grid.collectionView === undefined ||
        this.grid.collectionView === null) {
      return _items;
    }
    for (const item of this.grid.collectionView.itemsAdded) {
      item['gridStatus'] = GRID_STATUS.INSERT;
      _items.push(item);
    }
    for (const item of this.grid.collectionView.itemsEdited) {
      item['gridStatus'] = GRID_STATUS.UPDATE;
      _items.push(item);
    }
    for (const item of this.grid.collectionView.itemsRemoved) {
      item['gridStatus'] = GRID_STATUS.DELETE;
      _items.push(item);
    }
    return _items;
  }

  /**
   * 追加、変更、削除したデータを含む全てのデータを返す
   * @return {array} 状態（変更なし、追加、変更、削除）を設定したデータ
   */
  getAllItemsWithState() {
    const changedList = this.itemChangedList();
    let sc = this.getSourceCollection();
    const deleteItems =
      changedList.filter((data) => data.gridStatus == GRID_STATUS.DELETE);
    return sc.concat(deleteItems);
  }

  /**
   * 追加、変更、削除したデータを含む全てのデータを返す
   * @param {*} defaultGridStatus 一覧のステータスの初期値
   * @return {array} 状態（変更なし、追加、変更、削除）を設定したデータ
   */
  getItemsWithState(defaultGridStatus='') {
    // ユーザーが変更を元に戻すことがあるので、
    // gridStatusが更新の場合、gridStatusをクリアしておく
    // itemChangedListを実行して現在のgridStatusを一覧に反映する
    this.clearUpdateStatus(defaultGridStatus);
    const changedList = this.itemChangedList();
    let sc = this.getSourceCollection();
    const deleteItems =
      changedList.filter((data) => data.gridStatus == GRID_STATUS.DELETE);
    return sc.concat(deleteItems);
  }

  /**
   * 編集した内容をコミットする
   */
  commit() {
    const cv = this.grid?.collectionView;
    if (cv?.trackChanges) {
      cv.commitEdit();
    }
  }

  /**
   * データを追加、変更、削除したかチェックする
   * @return {bool} true:変更あり, false:変更なし
   */
  isItemsModified() {
    let _isModified = false;
    if (this.grid?.collectionView) {
      _isModified = this.grid.collectionView.itemsAdded.length > 0 ||
                  this.grid.collectionView.itemsEdited.length > 0 ||
                  this.grid.collectionView.itemsRemoved.length > 0;
    }
    return _isModified;
  }

  /**
   * 編集した内容をコミットし、データが変更されているかチェックする
   * グリッドが読み取り専用の場合はfalseを返す
   * @return {bool} true:変更あり, false:変更なし
   */
  commitAndCheck() {
    let _isModified = false;
    if (this.props.isReadOnly !== true) {
      this.commit();
      _isModified = this.isItemsModified();
    }
    return _isModified;
  }

  /**
   * グリッドのデータをDBに登録した後呼び出す。
   * clearChangesを実行すると
   * itemsAdded 、itemsRemoved 、itemsEdited
   * の全ての変更をクリアする。
   */
  clearChanges() {
    if (this.grid?.collectionView) {
      this.grid.collectionView.clearChanges();
    }
  }

  /**
   * グリッドステータスが更新の場合、グリッドステータスをクリアする
   * @param {*} defaultGridStatus 一覧のステータスの初期値
   */
  clearUpdateStatus(defaultGridStatus='') {
    const cv = this.grid.collectionView;
    cv.beginUpdate();
    const srcCollection = this.getSourceCollection();
    const updateSrc = srcCollection.filter(
        (d) => d.gridStatus === GRID_STATUS.UPDATE);
    for (const src of updateSrc) {
      cv.editItem(src);
      src.gridStatus = defaultGridStatus;
      cv.commitEdit();
    }
    cv.endUpdate();
  }

  /**
   * 画面の情報を設定する
   * @param {string} _screenId 画面Id
   * @param {bool} restore true:画面の状態を復元する、false:復元しない
   */
  setScreenState(_screenId, restore=true) {
    this.isRestore = restore;
    this.screenId = _screenId;
  }

  /**
   * 以下の状態を保存する
   * ・ラジオボタンまたはチェックボックスで選択したデータ
   * ・スクロール位置
   * @param {string} screenId 画面Id
   * @param {array} compareKey
   *                  一覧のデータと保存した選択データを比較して同じ行か判別するためのキー
   *                  selectedItemsに存在するキーを1つ設定する
   * @param {bool} isClear true: ストアに保存した状態をクリアする
   */
  saveScreenState(screenId, compareKey, isClear=false) {
    this.saveSelectedItems(screenId, compareKey, isClear);
    this.saveScrollPosition(screenId, isClear);
  }

  /**
   * ラジオボタンまたはチェックボックスで選択したデータを保存する
   * @param {string} screenId 画面Id
   * @param {array} compareKey
   *                  一覧のデータと保存した選択データを比較して同じ行か判別するためのキー
   *                  selectedItemsに存在するキーを1つ設定する
   * @param {bool} isClear true: ストアに保存した選択行をクリアする
   */
  saveSelectedItems(screenId, compareKey, isClear=false) {
    const _screenId = screenId + '_grid';
    if (!isClear) {
      let _dataItems = [];
      for (const selectedItem of this.selectedItems) {
        _dataItems.push(selectedItem.dataItem);
      }
      this.props.doSaveSelectedItems(
          _screenId, compareKey, _dataItems);
    } else {
      this.clearSelectedState();
      this.props.doSaveSelectedItems(
          _screenId, compareKey, null);
    }
  }

  /**
   * 一覧の選択状態をクリアする
   */
  clearSelectedState() {
    this.selectedItems = [];
    this.selectedOrders = [];
    this.radioCheckId = -1;
    if (this.grid && this.props &&
        this.props.rowHeaderType == 'radio') {
      this.grid.select(-1, -1);
    }
  }

  /**
   * スクロール位置を保存する
   * @param {string} screenId 画面Id
   * @param {bool} isClear true: ストアに保存した状態をクリアする
   */
  saveScrollPosition(screenId, isClear=false) {
    if (this.grid == null) {
      return;
    }
    const _screenId = this.screenId + '_grid';
    if (!isClear) {
      const _scrollPosition = this.grid.scrollPosition;
      this.props.doSaveScrollPosition(
          _screenId, _scrollPosition);
    } else {
      this.props.doSaveScrollPosition(
          _screenId, null);
    }
  }

  /**
   * nullチェック
   * @param {*} object
   * @return {bool} チェック結果
   */
  isNull(object) {
    return object == null || object == undefined;
  }

  /**
   * itemsSourceにCollectionView設定
   * @param {array} items
   */
  setItemsSource(items) {
    const {trackChanges, initItems, getError} = this.props;
    const self = this;

    // チェックボックス選択順をクリア
    this.selectedOrders = [];

    let setItemSource = function(grid) {
      const _columns = grid.columns;
      const dateCols = _columns.filter((col) =>
        col.dataType == wjCore.DataType.Date);
      const _tmpItems = items || [];
      let orgItems = Array.isArray(_tmpItems) ? _tmpItems : [_tmpItems];
      let _items = orgItems.map((item) => {
        let _tmp = {...item};
        for (const col of dateCols) {
          if (item && col.binding && Object.hasOwn(item, col.binding) &&
            !col.format) {
            _tmp[col.binding] = formatStringDate(item[col.binding]);
          }
        }
        return _tmp;
      });
      const cv = createCollectionView(
          _items, trackChanges, initItems, getError);
      grid.itemsSource = cv;
    };
    if (self.getGrid()) {
      setItemSource(self.getGrid());
      return;
    }
    let _counter = 0;
    const intervalId = setInterval(() => {
      _counter++;
      if (!self.getGrid()) {
        return;
      }
      if (_counter > 1000) {
        clearInterval(intervalId);
        return;
      }
      clearInterval(intervalId);
      setItemSource(self.getGrid());
    }, 1);
  }

  /**
   * 選択行に電柱情報を反映する
   * @param {object} editItem 選択行
   * @param {object} dnt 電柱選択画面の戻り値
   * @param {object} bindingAlias 電柱選択戻り値の項目を画面側の項目名に読み替える。
   *                              電柱情報を設定する前に編集対象データにbindingAliasの項目があればnullを設定する。
   * @param {func} callback
   */
  updateDnt(editItem, dnt, bindingAlias={}, callback=null) {
    if (!editItem || !dnt) {
      return;
    }
    const cv = this.grid.collectionView;
    cv.beginUpdate();
    cv.editItem(editItem);

    for (const dntKey of Object.keys(bindingAlias)) {
      const itemKey = bindingAlias[dntKey];
      // 前の情報をクリア
      if (Object.hasOwn(editItem, itemKey)) {
        editItem[itemKey] = null;
      }
      // 電柱の値を編集対象に設定
      if (Object.hasOwn(editItem, itemKey) &&
        Object.hasOwn(dnt, dntKey)) {
        editItem[itemKey] = dnt[dntKey];
      }
    }

    this.setDntIdType(editItem, dnt);
    this.setIdoType(editItem, dnt);

    if (callback) {
      callback(editItem);
    }

    cv.commitEdit();
    cv.endUpdate();
  }

  /**
   * 電柱情報を一覧に追加する
   * @param {object|array} dnt 電柱選択画面の戻り値
   * @param {object} bindingAlias 電柱選択戻り値の項目を画面側の項目名に読み替える
   */
  addDnt(dnt, bindingAlias={}) {
    if (!dnt || dnt.length == 0) {
      return;
    }
    const dntList = Array.isArray(dnt) ? dnt : [dnt];
    const cv = this.grid.collectionView;
    const _sourceCollection = cv.sourceCollection;
    const count = _sourceCollection.length + dntList.length;
    if (count > this.maxRowSize) {
      if (this.doShowMessage) {
        this.doShowMessage({
          message: {
            id: 'BFA000143E',
          },
        });
      }
      return;
    }
    cv.beginUpdate();
    let _nextRowId = this.getNextRowId(_sourceCollection);
    let _nextRowIndex = this.getNextRowIndex(_sourceCollection);
    let _nextBukkenNo = this.getNextBukkenNo(_sourceCollection);
    for (const data of dntList) {
      const _newItem = cv.addNew();
      if (_newItem) {
        _newItem['rowId'] = _nextRowId++;
        _newItem['rowIndex'] = _nextRowIndex++;
        if (_nextBukkenNo > 0) {
          _newItem['bukkenNo'] = _nextBukkenNo++;
        }
        for (const dntKey of Object.keys(data)) {
          const itemKey = bindingAlias?.[dntKey] ?
            bindingAlias[dntKey] : dntKey;
          if ( Object.hasOwn(_newItem, itemKey)) {
            _newItem[itemKey] = data[dntKey];
          }
        }
        this.setDntIdType(_newItem, data);
        this.setIdoType(_newItem, data);
        cv.commitNew();
      }
    }
    cv.endUpdate();
  }

  /**
   * 電柱情報を設備の一覧に追加する
   * @param {object|array} dnt 電柱選択画面の戻り値
   * @param {object} bindingAlias 電柱選択戻り値の項目を画面側の項目名に読み替える
   * @param {object} kisetuAlias 電柱選択の戻り値を既設の元値として別名で保持するための項目。
   *                              電柱複数追加の場合は初期化したデータに値を設定するので初期値は使用しない。
   *                             {電柱選択の変数: {key: 別名, initialValue: 初期値}}
   */
  addSetubiDnt(dnt, bindingAlias={}, kisetuAlias={}) {
    if (!dnt || dnt.length == 0) {
      return;
    }
    const dntList = Array.isArray(dnt) ? dnt : [dnt];
    const cv = this.grid.collectionView;
    const _sourceCollection = cv.sourceCollection;
    const count = _sourceCollection.length + dntList.length;
    if (count > this.maxRowSize) {
      if (this.doShowMessage) {
        this.doShowMessage({
          message: {
            id: 'BFA000143E',
          },
        });
      }
      return;
    }
    cv.beginUpdate();
    let _nextRowId = this.getNextRowId(_sourceCollection);
    let _nextRowIndex = this.getNextRowIndex(_sourceCollection);
    let _nextBukkenNo = this.getNextBukkenNo(_sourceCollection);
    for (const data of dntList) {
      const _newItem = cv.addNew();
      if (_newItem) {
        _newItem['rowId'] = _nextRowId++;
        _newItem['rowIndex'] = _nextRowIndex++;
        if (_nextBukkenNo > 0) {
          _newItem['bukkenNo'] = _nextBukkenNo++;
        }
        const isKisetu = (data.infoType === 'B');
        for (const dntKey of Object.keys(bindingAlias)) {
          const itemKey = bindingAlias[dntKey];
          // 電柱の値を編集対象に設定
          if (Object.hasOwn(_newItem, itemKey) &&
              Object.hasOwn(data, dntKey)) {
            _newItem[itemKey] = data[dntKey];
          }
        }
        // 既設設備の値を入力項目とは別の変数に保持する
        for (const dntKey of Object.keys(kisetuAlias)) {
          const item = kisetuAlias[dntKey];
          // 電柱の値を編集対象に設定
          if (isKisetu &&
            Object.hasOwn(_newItem, item.key) &&
            Object.hasOwn(data, dntKey)) {
            _newItem[item.key] = data[dntKey];
          }
        }

        this.setDntIdType(_newItem, data);
        this.setIdoType(_newItem, data);
        cv.commitNew();
      }
    }
    cv.endUpdate();
  }

  setDntIdType(target, dnt) {
    const key = 'dntIdType';
    if (!Object.hasOwn(target, key)) {
      return;
    }
    target[key] = getDntIdType(dnt);
  }

  setIdoType(target, dnt) {
    const key = 'idoType';
    if (!Object.hasOwn(target, key)) {
      return;
    }
    if (dnt.infoType == 'B') {
      // 共架物件マスタを選択した場合
      target[key] = IDO_TYPE.HAISHI;
    } else if (dnt.infoType == 'A') {
      // 電柱マスタを選択した場合
      target[key] = IDO_TYPE.SHINSETU;
    }
  }
}

/**
 * CollectionView生成
 * @param {array} items
 * @param {bool} trackChanges
 * @param {object} initItems
 * @param {func} getError
 * @return {object} CollectionView
 */
export function createCollectionView(
    items, trackChanges=true, initItems={}, getError=null) {
  const _list = [];
  const _items = items || [];
  const _initItems = initItems || {};
  let _index = 1;
  for (const item of _items) {
    let data = {};
    Object.assign(data, item);
    data['rowIndex'] = _index; // 内部管理用
    data['rowId'] = _index++; // 内部管理用
    _list.push(data);
  }
  const cv = new wjCore.CollectionView(
      _list,
      {
        trackChanges: trackChanges, // 変更管理ON
        newItemCreator: function() {
          // 項目は新しく作成すること
          // 同じ変数を返すとGridが同じ行とみなし、同じデータが入ってしまう
          const newItems = {};
          for (const key in _initItems) {
            if (Object.hasOwn(_initItems, key)) {
              newItems[key] = _initItems[key];
            }
          }
          return newItems;
        },
        getError: getError,
      },
  );
  return cv;
}

/**
 * GridColumn生成
 * @param {object} gridItems
 * @param {bool} isDisabled
 * @return {array} component
 */
export function createComponents(gridItems, isDisabled) {
  let component = [];
  if (!gridItems) {
    return component;
  }
  const keys = Object.keys(gridItems);
  let _currentParentHeader = gridItems[keys[0]].parentHeader;
  let _currentHeader = gridItems[keys[0]].groupHeader;
  let _currentColumns = [];
  let _currentCompoent = [];
  let _groupCount = 0;
  for (const key of keys) {
    const gridItem = gridItems[key];
    if (!gridItem.header) {
      continue;
    }
    if (_currentColumns.length > 0) {
      if (!_currentParentHeader) {
        if (!_currentHeader) {
          component.push(_currentColumns);
          _currentColumns = [];
        } else {
          if (_currentHeader != gridItem.groupHeader) {
            component.push(
                <FlexGridColumnGroup
                    key={'grouop-' + _groupCount++}
                    header={_currentHeader} align="center">
                  {_currentColumns}
                </FlexGridColumnGroup>);
            _currentColumns = [];
          }
        }
      } else {
        if (_currentHeader != gridItem.groupHeader) {
          _currentCompoent.push(
              <FlexGridColumnGroup
                  key={'grouop-' + _groupCount++}
                  header={_currentHeader} align="center">
                {_currentColumns}
              </FlexGridColumnGroup>);
          _currentColumns = [];
        }
        if (_currentParentHeader != gridItem.parentHeader) {
          component.push(
              <FlexGridColumnGroup
                  key={'grouop-' + _groupCount++}
                  header={_currentParentHeader} align="center">
                {_currentCompoent}
              </FlexGridColumnGroup>);
          _currentCompoent = [];
        }
      }
    }
    setColumn(gridItem, _currentColumns, isDisabled);
    _currentHeader = gridItem.groupHeader;
    _currentParentHeader = gridItem.parentHeader;
  }
  if (_currentColumns.length > 0) {
    if (_currentColumns.length == 1) {
      component.push(_currentColumns);
    } else {
      component.push(
          <FlexGridColumnGroup
              key={'grouop-' + _groupCount++}
              header={_currentHeader} align="center">
            {_currentColumns}
          </FlexGridColumnGroup>);
    }
  }
  return component;
}

function setColumn(gridItem, currentColumns, isDisabled) {
  const columnKey = 'column-' + gridItem.binding;
  if (gridItem.dataType == 'cellMaker') {
    currentColumns.push(
        <FlexGridColumnGroup
          key={columnKey}
          binding={gridItem.binding}
          header={gridItem.header} width={gridItem.width}
          visible={gridItem.visible}
          cellTemplate={CellMaker.makeButton({
            text: gridItem.text,
            cssClass: gridItem.disabled ? 'wj-state-disabled':gridItem.alwaysEditable ? 'bf-btn-navy' : isDisabled ? 'wj-state-disabled' : 'bf-btn-navy',
            click: gridItem.click,
            attributes: {
              tabindex: -1,
            },
          })}
        />);
  } else if (gridItem.dataType == 'Button') {
    currentColumns.push(
        <FlexGridColumnGroup
          key={columnKey}
          binding={gridItem.binding}
          header={gridItem.header} width={gridItem.width}
          visible={gridItem.visible}
          cellTemplate={CellMaker.makeButton({
            text: gridItem.text,
            cssClass: isDisabled ? 'wj-state-disabled' : 'bf-btn-navy',
            click: gridItem.click,
            attributes: {
              tabindex: -1,
            },
          })}
        />);
  } else if (gridItem.dataType == 'link') {
    currentColumns.push(
        <FlexGridColumnGroup
          key={columnKey}
          binding={gridItem.binding}
          header={gridItem.header} width={gridItem.width}
          visible={gridItem.visible}
          cellTemplate= {CellMaker.makeLink({
            click: gridItem.click,
          })}
          dataType='String'
        />);
  } else if (gridItem.dataType == 'Date') {
    currentColumns.push(<FlexGridColumnGroup
          key={columnKey}
      binding={gridItem.binding} header={gridItem.header}
      format={gridItem.format}
      editor={gridItem.editor} width={gridItem.width}
      isReadOnly={gridItem.isReadOnly} isRequired={false}
      visible={gridItem.visible}
      cssClass='bf-rightPos'
    />);
  } else if (gridItem.dataType == 'Boolean') {
    currentColumns.push(<FlexGridColumnGroup
      key={columnKey}
      binding={gridItem.binding} header={gridItem.header}
      dataType={gridItem.dataType} width={gridItem.width}
      isReadOnly={gridItem.isReadOnly}
      visible={gridItem.visible}/>);
  } else if (gridItem.dataType == 'Number') {
    currentColumns.push(<FlexGridColumnGroup
      key={columnKey}
      binding={gridItem.binding} header={gridItem.header}
      dataType={gridItem.dataType} width={gridItem.width}
      format={gridItem.format}
      isReadOnly={gridItem.isReadOnly} isRequired={false}
      visible={gridItem.visible} maxWidth={gridItem.maxwidth}
    />);
  } else if (gridItem.dataType == 'String') {
    if ('dataMap' in gridItem) {
      let prop = {
        binding: gridItem.binding,
        header: gridItem.header,
        dataType: gridItem.dataType,
        width: gridItem.width,
        dataMap: gridItem.dataMap,
        isReadOnly: gridItem.isReadOnly,
        visible: gridItem.visible,
        quickAutoSize: gridItem.quickAutoSize,
      };
      if ('cssClass' in gridItem) {
        prop.cssClass = gridItem.cssClass;
      }
      currentColumns.push(<FlexGridColumnGroup
          key={columnKey} {...prop} />);
    } else {
      const _multiLine = 'multiLine' in gridItem ? gridItem.multiLine : false;
      const _cssClass = 'cssClass' in gridItem ? gridItem.cssClass : 'bf-leftPos';
      let prop = {
        binding: gridItem.binding,
        header: gridItem.header,
        dataType: gridItem.dataType,
        multiLine: _multiLine,
        cssClass: _cssClass,
      };
      if ('width' in gridItem) {
        prop.width = gridItem.width;
      }
      if ('isReadOnly' in gridItem) {
        prop.isReadOnly = gridItem.isReadOnly;
      }
      if ('visible' in gridItem) {
        prop.visible = gridItem.visible;
      }
      if ('maxwidth' in gridItem) {
        prop.maxWidth = gridItem.maxwidth;
      }
      if ('maxLength' in gridItem) {
        prop.maxLength = gridItem.maxLength;
      }
      if ('quickAutoSize' in gridItem) {
        prop.quickAutoSize = gridItem.quickAutoSize;
      }
      currentColumns.push(<FlexGridColumnGroup
          key={columnKey} {...prop} />);
    }
  }
}

CustomFlexGrid.propTypes = {
  AddDeleteOn: PropTypes.bool,
  DeleteOn: PropTypes.bool,
  AddAdditionOn: PropTypes.bool,
  allowDragging: PropTypes.string,
  allowSorting: PropTypes.string,
  checkedFunction: PropTypes.func,
  children: PropTypes.array,
  isDisplayCount: PropTypes.bool,
  data: PropTypes.array,
  exceptFilters: PropTypes.array,
  filterOn: PropTypes.bool,
  frozenRows: PropTypes.number,
  frozenColumns: PropTypes.number,
  maxRowSize: PropTypes.number,
  headersVisibility: PropTypes.string,
  rowHeaderType: PropTypes.string,
  itemsSource: PropTypes.array,
  style: PropTypes.object,
  isReadOnly: PropTypes.bool,
  initItems: PropTypes.object,
  validateEdits: PropTypes.bool,
  selections: PropTypes.array,
  scrollPosition: PropTypes.array,
  radioId: PropTypes.string,
  doShowMessage: PropTypes.func,
  getError: PropTypes.func,
  doSaveSelectedItems: PropTypes.func,
  doSaveScrollPosition: PropTypes.func,
  trackChanges: PropTypes.bool,
  isRestore: PropTypes.bool,
  screenId: PropTypes.string,
  editPopupItems: PropTypes.func,
  loadedRowsFunction: PropTypes.func,
  refreshedFunction: PropTypes.func,
  formatItemFunction: PropTypes.func,
  beginningEditFunction: PropTypes.func,
  cellEditEndedFunction: PropTypes.func,
  cellEditEndingFunction: PropTypes.func,
  addItemFunction: PropTypes.func,
  deleteRowFunction: PropTypes.func,
  selectionChangedFunction: PropTypes.func,
  itemsSourceChangedFunction: PropTypes.func,
  pastingCellFunction: PropTypes.func,
  pastedCellFunction: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    selections: state.grid.selections != null ? state.grid.selections : [],
    scrollPosition:
      state.grid.scrollPosition != null ? state.grid.scrollPosition : [],
  };
};

const mapDispatchToProps = {
  doSaveSelectedItems: gridOperations.doSaveSelectedItems,
  doSaveScrollPosition: gridOperations.doSaveScrollPosition,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {forwardRef: true},
)(CustomFlexGrid);
